import React from "react";
import Footer from "../../Components/Footer/Footer";
import Navbar from "../../Components/Navbar/Navbar";
import SEO from "../../Components/SEO/SEO";
import { HOME_META } from "../../seo/pageMeta";
import { useTranslation } from "react-i18next";
import About from "./About/About";
import BizCategories from "./BizCategories/BizCategories";
import BookAppointment from "./BookAppointment/BookAppointment";
import ContactSec from "./ContactSec/ContactSec";
import FAQ from "./FAQ/FAQ";
import GetPaid from "./GetPaid/GetPaid";
import Header from "./Header/Header";
import NearbySalons from "./NearbySalons/NearbySalons";
import UseStylon from "./UseStylon/UseStylon";
import BookDemoCTA from "../../Components/BookDemoCTA/BookDemoCTA";
import { TEMP_CRM_PIVOT } from "../../config/tempCrmPivot";

// page_view + scroll-depth fire from src/App.js TrackPageViews so they
// cover every route, not just home. Don't re-fire them here.

const Home = () => {
  const { t } = useTranslation();

  /**
   * FAQPage built from the eight FAQs this page actually renders.
   *
   * It used to come from a hand-written list in pageMeta.js whose questions
   * were different from the visible ones -- five of its six appeared nowhere
   * on the page. Google requires FAQ content to be visible, so deriving the
   * markup from the same translation keys the FAQ section reads is the only
   * version that cannot drift out of agreement with the page.
   */
  const homeFaqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [1, 2, 3, 4, 5, 6, 7, 8].map((n) => ({
      "@type": "Question",
      name: t(`faq.q${n}`),
      acceptedAnswer: { "@type": "Answer", text: t(`faq.a${n}`) },
    })),
  };

  // `clip`, not `hidden`: `hidden` makes this wrapper a scroll container, and a
  // scroll container is what `position: sticky` sticks to — with it, the navbar
  // inside scrolled away and took the menu button with it (see index.css).
  return (
    <div style={{ overflowX: "clip", maxWidth: "100vw" }}>
      <SEO {...HOME_META} jsonLd={[...(HOME_META.jsonLd || []), homeFaqJsonLd]} />
      <Navbar />
      <Header />
      {!TEMP_CRM_PIVOT && <BizCategories />}
      <About />
      <BookAppointment />
      <NearbySalons />
      <GetPaid />
      <UseStylon />
      <FAQ />
      <BookDemoCTA />
      <ContactSec />
      <Footer />
    </div>
  );
};

export default Home;
